import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// import 'core-js/stable';
import Gtm from "./gtm";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Google Analytics tracking
 */
window.gtm = new Gtm;

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/App');

/**
 * GDPR cookies consent
 */
if (localStorage.getItem('INBANKGDPRLT:accepted')) {
    document.getElementById('inbank-gdpr-lt').style.display = 'none';
    document.getElementById('inbank-gdpr-lt').classList.add('d-none');
    document.getElementById('inbank-gdpr-lt').classList.remove('d-lg-flex');
} else {
    document.getElementById('inbank-gdpr-lt').classList.add('d-lg-flex');
    document.getElementById('inbank-gdpr-lt').classList.remove('d-none');
}

function setCookieGdprAccepted() {
    localStorage.setItem('INBANKGDPRLT:accepted', true);
    document.getElementById('inbank-gdpr-lt').style.display = 'none';
    document.getElementById('inbank-gdpr-lt').classList.add('d-none');
    document.getElementById('inbank-gdpr-lt').classList.remove('d-lg-flex');
}
window.setCookieGdprAccepted = setCookieGdprAccepted;
